import { FC } from 'react';
import { Flex } from '@chakra-ui/react';

import AsideOfferCard from 'features/Insurance/components/AsideOfferCard';
import AskQuestionIntercomButton from 'features/Insurance/components/AskQuestionIntercomButton';
import { AssuredBy, Offer } from 'features/Insurance/types';
import * as Layout from 'layouts/OfferDetailsLayout';

import { IGuarantees } from '../GuaranteesList';

export interface IGuaranteesList {
  include: IGuarantees;
  exclude: IGuarantees;
}

interface ContentWrapperProps {
  offer: Offer;
  offerName: string;
  assuredBy: AssuredBy;
  children: JSX.Element;
}

const ContentWrapper: FC<ContentWrapperProps> = ({
  assuredBy,
  children,
  offer,
}) => {
  return (
    <Flex marginBottom="space-40">
      <Layout.Aside>
        <AsideOfferCard assuredBy={assuredBy} offer={offer} />
        <AskQuestionIntercomButton offer={offer.title} />
      </Layout.Aside>
      <Flex direction="column">{children}</Flex>
    </Flex>
  );
};

export default ContentWrapper;
